import { useEffect, useRef } from 'react';
import { paintLivePrivacyMaskOverlay } from '../utils/paintLivePrivacyMask';

export function StreamPrivacyMaskCanvas({ videoEl, active }) {
    const canvasRef = useRef(null);
    const rafRef = useRef(0);

    useEffect(() => {
        if (!active || !videoEl) return undefined;

        const canvas = canvasRef.current;
        if (!canvas) return undefined;

        let running = true;

        const tick = () => {
            if (!running) return;
            rafRef.current = requestAnimationFrame(tick);
            paintLivePrivacyMaskOverlay(canvas, videoEl);
        };

        const onResize = () => {
            paintLivePrivacyMaskOverlay(canvas, videoEl, { force: true });
        };

        rafRef.current = requestAnimationFrame(tick);
        window.addEventListener('resize', onResize);
        videoEl.addEventListener('loadeddata', onResize);

        return () => {
            running = false;
            cancelAnimationFrame(rafRef.current);
            window.removeEventListener('resize', onResize);
            videoEl.removeEventListener('loadeddata', onResize);
        };
    }, [active, videoEl]);

    if (!active) return null;

    return (
        <canvas
            ref={canvasRef}
            className="stream-privacy-canvas pointer-events-none absolute inset-0 z-[13]"
            aria-hidden
        />
    );
}
